import { render, staticRenderFns } from "./BaseCodemirror.vue?vue&type=template&id=126fd2d4"
import script from "./BaseCodemirror.vue?vue&type=script&lang=js"
export * from "./BaseCodemirror.vue?vue&type=script&lang=js"
import style0 from "./BaseCodemirror.vue?vue&type=style&index=0&id=126fd2d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports